<template>
    <div class="modal__buttons text-center text-md-right">
        <button type="button" class="modal__buttons__item cancel" data-dismiss="modal" aria-label="Close" v-html="'Cancel'"/>

        <button class="modal__buttons__item" v-html="`Save & complete <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`" @click="save_and_close(); clicking(); save_and_view();" v-if="save_view"/>

        <button class="modal__buttons__item" v-html="`Save & new <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`" @click="clicking();"/>

        <button class="modal__buttons__item" v-html="`Save & close <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`" @click="save_and_close(); clicking();"/>
    </div>
</template>

<script>
import eventBus from '@/plugins/eventBus'

export default {
    name: 'CentralButtons',

    props:[
        'modal_name',
        'save_view',
    ],

    data() {
        return {
            close: false,
            clicked: false
        }
    },

    async created() {

        eventBus.$on('spliceObject', () => {
            if (this.clicked)
            {
                this.LoaderOffModalOn(this.modal_name, this.close)
                this.close = false
                this.clicked = false
            }
        })

        eventBus.$on('unshiftObject', () => {
            if (this.clicked)
            {
                this.LoaderOffModalOn(this.modal_name, this.close)
                this.close = false
                this.clicked = false
            }
        })

    },
    
    methods: {

        save_and_close()
        {
            this.close = true
            eventBus.$emit('saveAndNew', false )
        },

        clicking()
        {
            this.clicked = true
        },

        save_and_view()
        {
            this.$emit('saveView', true)
        }

    },
    
}
</script>